<!--领取成功弹窗-->
<template>
  <SFiveModalCommon ref="SFiveModalCommon"
                    title="恭喜你获得"
  >
    <div class="content" >
      <div class="img-list">
        <div class="item-wrap" v-for="(item, index) in list" :key="index">
          <img :src="item.icon" alt="">
          <p>{{item.name}} <span v-if="item.amount && item.amount > 1"> x {{item.amount}}</span></p>
        </div>
      </div>
      <div class="text">{{ tipText }}</div>
    </div>
    <div class="s-btn-wrap">
      <div :style="modalConfirmBtnStyleObj" class="btn btn-confirm hv-highlight" @click="close">{{btnText}}</div>
    </div>
  </SFiveModalCommon>

</template>

<script>
import SFiveModalCommon from './FiveModalCommon.vue'
export default {
  name: 'SFiveModalReceive',
  components: {
    SFiveModalCommon
  },
  props: {
    title: {
      type: String,
      default: '恭喜获得'
    },
    btnText: {
      type: String,
      default: '开心收下'
    }
  },
  inject: {
    // 由 FiveWrap 组件传入
    $MainWrap: {
      default: () => null
    }
  },
  data () {
    return {
      visible: false,
      shareLink: '',
      coverUrl: '',
      list: [],
      tipText: '请前往游戏内邮箱查收'
    }
  },
  computed: {
    modalConfirmBtnStyleObj () {
      try {
        return JSON.parse(this.$MainWrap.modalConfirmBtnStyle)
      } catch (e) {
        console.error('titleStyle 格式错误')
        return {}
      }
    }
  },
  async mounted () {
  },
  methods: {
    /**
     * 打开弹窗
     * @param awardsList 奖励列表 [{name: 'xxx', icon: 'xxx.png', amount: 1}]
     * @returns {Promise<void>}
     */
    async open (awardsList) {
      if (!awardsList || !awardsList.length) {
        console.error('awardsList is empty')
        return
      }
      this.list = awardsList || []
      this.$refs.SFiveModalCommon.open()
    },
    close () {
      this.$refs.SFiveModalCommon.close()
    }
  }
}
</script>

<style scoped lang="scss">
//@import "../common.scss";
.content{
  margin-bottom: 0px;
}
.img-list{
  height: 350px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  .item-wrap{
    margin: 0 20px 10px;
    img{
      display: block;
      width: 173px;
      height: 161px;
      margin: 0 auto 10px;
      border-radius: 4px;
      box-shadow: 0 0 5px #ccc;
      padding: 15px;
      background-color: rgba(0, 0, 0, 0.3);
      object-fit: contain;
    }
    p{
      font-size: 20px;
      letter-spacing: normal;
      text-align: center;
      //color: #fff;
      //text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    }
  }
}
.text{
  margin-top: 20px;
  text-align: center;
  font-size: 24px;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
}
.s-btn-wrap{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.btn-confirm{
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  width: 222px;
  height: 61px;
  line-height: 61px;
  color: #fff;
}
</style>
